import { action, thunk } from 'easy-peasy';
import { httpGetPools, httpGetPool, httpCreatePool, httpUpdatePool, httpDeletePool } from "services/pools";

const model = {
  loading: false,
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  
  pools: [],
  setPools: action((state, payload) => {
    state.pools = payload
  }),
  
  addPool: action((state, payload) => {
    // Check if pool already exists to avoid duplicates
    const exists = state.pools.some(pool => pool.id === payload.id);
    if (!exists) {
      state.pools = [...state.pools, payload];
    } else {
      // If exists, update instead
      state.pools = state.pools.map(pool => 
        pool.id === payload.id ? payload : pool
      );
    }
  }),
  
  updatePoolInState: action((state, payload) => {
    state.pools = state.pools.map(pool => 
      pool.id === payload.id ? payload : pool
    )
  }),
  
  removePool: action((state, payload) => {
    state.pools = state.pools.filter(pool => pool.id !== payload)
  }),
  
  getPools: thunk(async (actions, payload) => {
    actions.setLoading(true)
    
    try {
      const response = await httpGetPools(payload)
      actions.setPools(response?.data || [])
    } catch (error) {
      console.error('Error fetching pools:', error)
    } finally {
      actions.setLoading(false)
    }
  }),
  
  getPool: thunk(async (actions, id) => {
    actions.setLoading(true)
    
    try {
      const response = await httpGetPool(id)
      return response?.data
    } catch (error) {
      console.error('Error fetching pool:', error)
      return null
    } finally {
      actions.setLoading(false)
    }
  }),
  
  createPool: thunk(async (actions, data) => {
    actions.setLoading(true)
    
    try {
      const response = await httpCreatePool(data)
      actions.addPool(response?.data)
      return response?.data
    } catch (error) {
      console.error('Error creating pool:', error)
      throw error
    } finally {
      actions.setLoading(false)
    }
  }),
  
  updatePool: thunk(async (actions, { id, data }) => {
    actions.setLoading(true)
    
    try {
      const response = await httpUpdatePool(id, data)
      actions.updatePoolInState(response?.data)
      return response?.data
    } catch (error) {
      console.error('Error updating pool:', error)
      throw error
    } finally {
      actions.setLoading(false)
    }
  }),
  
  deletePool: thunk(async (actions, id) => {
    actions.setLoading(true)
    
    try {
      await httpDeletePool(id)
      actions.removePool(id)
    } catch (error) {
      console.error('Error deleting pool:', error)
      throw error
    } finally {
      actions.setLoading(false)
    }
  }),
  
  count: 0,
  setCount: action((state, payload) => {
    state.count = payload
  }),
};

export default model; 